export default __webpack_public_path__ + "11514f48f22f6d8e3cf748e45e3e1ffb.png";